<template>
    <div class="edit_price">
        <p class="tit">编辑价格</p>
        <div class="price1">
            <p class="le">原价</p>
            <p class="ri">&yen;<span>{{ price }}</span></p>
        </div>
        <div class="price2">
            <p>请输入调整后金额</p>
            <div class="ipt" :class="{'active': !disabled}">
                <input type="number" placeholder="请输入金额" v-model="new_price">
            </div>
        </div>
        <div class="btns">
            <button class="cancel" @click="close">取消</button>
            <button class="submit" :disabled="disabled" @click="success">提交</button>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                price: this.selection.price,
                goods_id: this.selection.goods_id,
                new_price: '',
                disabled: true
            }
        },
        computed: {},
        created() {},
        mounted() {},
        methods: {
            close() {
                this.$emit('closeModal')
            },
            success() {
                if(Number(this.new_price)<100 || Number(this.new_price) > 500000) {
                    this.new_price = ''
                    this.$toast('100.00≤售价≤500000.00')
                    return
                }
                this.$Ajax('goods-role/modify-price',{
                    goods_id: this.goods_id,
                    price: this.new_price,
                    // is_negotiate //是否开启议价 0否 1是 默认0 没写
                }).then(rs => {
                    if(rs.code == 200) {
                        this.$toast('价格修改成功')
                        this.$emit('success')
                    }
                })
            }
        },
        watch: {
            new_price: {
                immediate:true,
                handler(e) {
                   if(e.trim() != '' && e.trim() != 0) {
                    this.disabled = false
                   }else {
                    this.disabled = true
                   }
                }
            }
        },
    }
</script>

<style lang="less" scoped>
.edit_price {
    padding: 2.1rem 1.3rem 1.7rem;
    .tit {
        text-align: center;
        font-size: 1.6rem;
        font-weight: 700;
        margin-bottom: 1.9rem;
    }
    .price1 {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 1rem;
        .le {
            font-size: 1.4rem;
        }
        .ri {
            font-size: 1.4rem;
            color: #EF4D3D;
            span {
                font-size: 1.6rem;
                font-weight: 700;
            }
        }
    }
    .price2 {
        p {
            margin-bottom: 1rem;
            font-size: 1.4rem;
        }
        input {
            width: 100%;
            height: 3.8rem;
            border: none;
            outline: none;
            padding: 0 1.3rem;
            font-size: 1.4rem;
            background-color: transparent;
            &::placeholder {
                color: #a4a4a4;
            }
        }
        .ipt {
            border-radius: 1rem;
            border: 1px solid #a4a4a4;
            overflow: hidden;
            &.active {
                background-color: #FFE4D8;
                border-color: var(--theme);
                text-align: end;
                position: relative;
                padding-left: 3rem;
                input {
                    text-align: end;
                }
                &::before {
                    content: '¥';
                    z-index: 10;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    left: 1.3rem;
                    font-size: 1.2rem;
                    color: #000;
                }
            }
        }

    }
    .btns {
        margin-top: 2rem;
        display: flex;
        justify-content: space-between;
        button {
            width: 48%;
            height: 3.2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 10rem;
            font-size: 1.6rem;
            border: 1px solid #a4a4a4;
            &.cancel {
                color: #a4a4a4;
                background-color: transparent;
                &:active {
                    opacity: 0.9;
                }
            }
            &.submit {
                border-color: var(--theme);
                background-color: var(--theme);
                color: #fff;

                &:disabled {
                    background-color: #a4a4a4;
                    border-color: #a4a4a4;
                }
            }
        }
    }
}
</style>